import {AlteraAtendimento} from "./altera-atendimento";

export class DetalhesAtendimento extends AlteraAtendimento{
}
